export default {
  lucky: {
    prizeAgain: 'もう一回',
    prizeThanks: '残念でした',
    remainingChance: '残り回数',
    task: 'タスク',
    deposit: '入金',
    wager: 'ベット',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'カード集め',
    puzzleRound: 'ラウンド {current}/{total}',
    puzzleReward: 'コンプリート報酬 {amount}',
    redeem: '交換する',
    redeemSuccess: '交換に成功しました',
    redeemSuccessWithReward: '交換に成功しました！{amount} {currency} を獲得しました',
    redeemFailed: '交換に失敗しました',
    notComplete: 'まだ完成していません。交換できません',
    drawFailed: '抽選に失敗しました。もう一度お試しください',
    gainLetter: 'おめでとうございます！文字 {letter} を獲得しました',
    gainBlock: 'おめでとうございます！画像 {blockNo} を獲得しました',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: '招待する',
    claimReward: '受け取る',
    noChest: '宝箱なし',
    claimSuccess: '{count} 個の宝箱を受け取り、{amount} {currency} を獲得しました',
    modalTitle: '宝箱',
    modalSubtitle: 'スワイプしてすべて表示',
    chipTodayClaimed: '本日受取済',
    chipClaimable: '受取可能',
    chipLocked: '未開放',
    totalClaimedCount: '受取済宝箱数',
    totalClaimedAmount: '受取済合計金額',
    chestUnit: '個',
    claimAll: '一括受取',
    goInvite: '友達を招待',
    claimSingleSuccess: '{amount} {currency} を受け取りました',
    labelClaimed: '受取済',
    labelClaimable: '受取可能',
    labelLocked: '未開放',
  },
}
